export default __webpack_public_path__ + "static/media/LoveRead.79896150.png";